import { ApiError } from "./ApiError";
import { Title } from "./base/Title";

type typeLoading = 'no-data' | 'error' | 'loading';

export const ApiLoading = ({ children, type }: { children: React.ReactNode, type: typeLoading }) => {
  return (
    <div className={`flex justify-center ${type === 'error' ? '' : 'items-center min-h-container -my-4'}`}>
      {type === 'loading' && (
        <div className="flex flex-col items-center justify-center animate-pulse">
          <div className="animate-spin">
            <img src="/loading.svg" alt="Image de chargement" className="h-14 w-auto" />
          </div>
          <Title type="h2" className="ont-extrabold mb-2">
            {children}
          </Title>
        </div>
      )}
      {type === 'no-data' && (
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center gap-4 mb-6">
            <img src="/404.png" alt="Image de données non trouvées" className="w-14" />
            <Title type="h2" className="ont-extrabold mb-2 animate-pulse">
              {children}
            </Title>
          </div>
        </div>
      )}
      {type === 'error' && (
        <ApiError>{children}</ApiError>
      )}
    </div>);
};

